import getBestBidColumn from "./getBestBidColumn"
const event_savings_column = {
  "actual_formula": "", 
  "alternate_bid_from_supplier" : "no",
  "decimal_spaces": 0, 
  "formula": "",
  "input_field_type": "Price", 
  "is_column_hidden": false, 
  "price_transformation_factor": "no",
  "required_for_formula": "no", 
  "requires_a_total": "yes", 
  "supplier_can_see": "yes", 
  "term_name": "Event Savings", 
  "ucid": "event_saving", 
  "who_fills": "Buyer"
}

const best_bid_column = {
  "actual_formula": "", 
  "alternate_bid_from_supplier" : "no",
  "decimal_spaces": 0, 
  "formula": "",
  "input_field_type": "Price", 
  "is_column_hidden": false, 
  "price_transformation_factor": "no",
  "required_for_formula": "no", 
  "requires_a_total": "yes", 
  "supplier_can_see": "yes", 
  "term_name": "Best Bid", 
  "ucid": "best_bid", 
  "who_fills": "Buyer"
}

const percentage_away_from_best_bid = {
  "actual_formula": "", 
  "alternate_bid_from_supplier" : "no",
  "decimal_spaces": 0, 
  "formula": "",
  "input_field_type": "Percentage",
  "is_column_hidden": false, 
  "price_transformation_factor": "no",
  "required_for_formula": "no", 
  "requires_a_total": "yes", 
  "supplier_can_see": "yes", 
  "term_name": "% above Best Bid", 
  "ucid": "percentage_away_from_best_bid", 
  "who_fills": "Supplier"
}

function setColumnsForLot(response, eventInfo) {
    response.column_data_for_buyer = response.items.column_data.filter(
      (col) => col.who_fills === 'Buyer' && (col.price_transformation_factor === 'no' || !col.price_transformation_factor)
    )
    if (response.bid_action !== 'e') {  // best bid columns should not be there for dutch-partial quantity
      response.column_data_for_buyer.push(best_bid_column)
    }
    response.column_data_for_buyer.push(event_savings_column)
    
    response.column_data_for_supplier = response.items.column_data.filter(
      (col) => !(col.who_fills === 'Buyer' && (col.price_transformation_factor === 'no' || !col.price_transformation_factor))
    )
  
    response.alternateBidColumns = response.column_data_for_buyer.filter(
      (col) => col.alternate_bid_from_supplier === 'yes' && !col.is_column_hidden
    )
    
    if (response.bid_action && response.bid_action === 'e') {
      const qtyColumnIndex = response.column_data_for_buyer.findIndex(
        (col) => col.ucid === 'quantity'
      )
      response.column_data_for_supplier.unshift(response.column_data_for_buyer[qtyColumnIndex])
      response.column_data_for_buyer[qtyColumnIndex] = {
        ...response.column_data_for_buyer[qtyColumnIndex], 
        term_name: 'Total Supplier Quantity'
      }
    }
  
    const supplier_data_not_needed_columns = response.items.column_data.filter(
      (col) => col.who_fills === 'Supplier'
    )
    
    if (supplier_data_not_needed_columns.length > 0) {
      response.data_not_needed = true
    } else {
      response.data_not_needed = false
    }
    if (response.bid_action !== 'e'){
      let termName = "% above Best Bid"
      const isSourcingSell = eventInfo.event_type === 'sourcing' && eventInfo.sourcing_type === 'sell';
      const isForwardAuction = eventInfo.event_type === 'auction' && eventInfo.auction_type === 'b';
      const isDutchAuctionWithDecreasingPrice = eventInfo.event_type === 'auction' && eventInfo.auction_type === 'c' && eventInfo.price_movement === 'decreases';
      if (
          isSourcingSell
          || isForwardAuction 
          || isDutchAuctionWithDecreasingPrice
      ) {
          termName = "% below Best Bid";
      }
      const bestBidColumnId = getBestBidColumn(response)
      let indexOfBestBidColumn = response.column_data_for_supplier.findIndex(obj => obj.ucid === bestBidColumnId);
      response.column_data_for_supplier.splice(
        indexOfBestBidColumn+1,
        0,
        {
        ...percentage_away_from_best_bid,
        term_name: termName
      })
    }
    response.normalSupplierColumns = response.column_data_for_supplier;
    response.alternateSupplierColumns = [
      ...response.alternateBidColumns,
      ...response.column_data_for_supplier
    ]
    response.setColumns = response.column_data_for_buyer.concat(response.column_data_for_supplier)
    return response
}

export default setColumnsForLot;